/* eslint-disable no-unused-vars */
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { FiLock, FiMail, FiMapPin, FiPhone, FiUser } from 'react-icons/fi';
import { useHistory } from 'react-router';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { ToString } from '../../../shared/constants';
import { signUp } from '../network';

export const RegistrationForm = () => {
  const router = useHistory();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Form
      className='premium-form'
      layout='vertical'
      form={form}
      labelCol={{ span: 15 }}
      wrapperCol={{ span: 25 }}
      initialValues={{}}
      scrollToFirstError
      onFinish={async (dataForm) => {
        setIsLoading(true);

        await signUp(dataForm)
          .then(({ statusCode, data }) => {
            if (statusCode.toString()[0] === '2') {
              router.push(ROUTES.SIGNIN);
            } else {
              notification.error({
                message: `Erreur ${statusCode}`,
                description: ToString(data),
              });

              setIsLoading(false);
            }
          })
          .catch((err) => {
            notification.error({
              message: 'Erreur',
              description: err.message,
            });
          });
      }}
    >
      <div className='form-grid'>
        <Form.Item
          label='Nom'
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Veuillez renseigner votre nom',
            },
          ]}
        >
          <Input prefix={<FiUser />} placeholder='nom' />
        </Form.Item>

        <Form.Item
          label='Prénom'
          name='prenom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Veuillez renseigner votre prénom',
            },
          ]}
        >
          <Input prefix={<FiUser />} placeholder='prénom' />
        </Form.Item>
      </div>

      <Form.Item
        label='Email'
        name='email'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre mail',
          },
          {
            type: 'email',
            message: "Le format de l'email n'est pas respecté",
          },
        ]}
      >
        <Input prefix={<FiMail />} placeholder='email' />
      </Form.Item>
      <Form.Item
        label='Téléphone (avec indicatif)'
        name='mobile'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre numéro de téléphone',
          },
        ]}
      >
        <Input prefix={<FiPhone />} placeholder='Téléphone' />
      </Form.Item>

      <Form.Item label='Adresse' name='adresse'>
        <Input prefix={<FiMapPin />} placeholder='adresse' />
      </Form.Item>

      <Form.Item label='Nationalité' name='nationalite'>
        <Input prefix={<FiMapPin />} placeholder='nationalité' />
      </Form.Item>

      <Form.Item
        label='Mot de passe'
        name='password'
        hasFeedback
        rules={[
          {
            required: true,
            message: 'Veuillez renseigner votre mot de passe',
          },
        ]}
      >
        <Input.Password prefix={<FiLock />} placeholder='mot de passe' />
      </Form.Item>

      <Form.Item>
        <Button
          type='primary'
          htmlType='submit'
          loading={isLoading}
          size='large'
          style={{
            width: '100%',
            height: 46,
            background: `linear-gradient(135deg, ${ORANGE}, ${YELLOW})`,
            borderColor: 'transparent',
            borderRadius: 999,
            color: '#07141c',
            fontFamily: 'Poppins-B',
          }}
        >
          Créer mon accès
        </Button>
      </Form.Item>
    </Form>
  );
};
